import fpApiUtil from "./fp-api-util";

const ADJUSTMENT = "factoryplan/adjustment";

// 보정 간트 차트 — AdjustmentController#getGanttActivities(gantt/activities).
// 응답 구조는 자원 간트(`AdjustmentGanttResultDto`)와 같은 계열이라 화면의 행/박스 조립 코드도 같다.
// **행 내부 activities가 startTs 정렬이라는 보장이 없다** — 화면에서 행마다 다시 정렬한다
// (자원 간트와 동일한 함정, reports/gantt-implementation.md §5-2a F1).
const getActivities = (params) => fpApiUtil.postParams(`${ADJUSTMENT}/gantt/activities`, params);

// 대체 자원(공정 기준) — `Map<routeCd, [{ resourceCd, … }]>`.
// 보정 화면에서는 강조 표시뿐 아니라 **드래그 드롭 허용 자원 판정**에 쓰인다(old OnGanttRunDrop의
// `FP_WARN_MOVE_RESOURCE` 가드 이식).
const getAltResources = (params) => fpApiUtil.postParams(`${ADJUSTMENT}/alt-resources`, params);

// ⚠️ **보정 쓰기 경로 3종은 백엔드에 없다.**
//   `gantt/activities/save` / `gantt/arranged-activities` / `gantt/arranged-activities/shift`
// old `AdjustmentController.java:84~126`이 통째로 블록 주석(`// Adjustment Back단 기능 제거`)이고
// `saas-fp`에도 대응 메서드가 없다. old 프론트도 같은 3기능을 껐다(저장 버튼은 "미지원" 메시지).
// 프로젝트별 요구사항 차이로 **의도적으로 중단**된 것이라 `backend-gaps.md`가 아니라
// `deferred-features.md`에 등재한다. 재개하려면 백엔드 주석 해제가 선행이다.
// 상세: reports/gantt-implementation.md §6-1.

// JC 기준정보 번들 — 공정 순서가 바뀔 때 화면이 JC 를 다시 계산하는 데 쓴다(§7-59).
// `{ resources, routeGroups, routeMx, routeGrpMx, itemMx, itemGrpMx }`. **시간은 전부 ms 로
// 정규화돼서 온다** — 원본 테이블은 행마다 `time_uom` 이 달라질 수 있는데, 그 환산을 화면에
// 복제하면 엔진과 갈린다. 해석 규칙은 `common/gantt/jcMaster.js` 주석 참고.
//
// ⚠️ **활동 조회와 따로 부른다.** 이 마스터는 버전이 아니라 **planScope 에 종속**이라
// 버전만 바꿔 재조회할 때 다시 받을 필요가 없다.
const getJcMaster = (params) => fpApiUtil.postParams(`${ADJUSTMENT}/jc-master`, params);

const fpAdjustmentGanttService = { getActivities, getAltResources, getJcMaster };
export default fpAdjustmentGanttService;
